import React, {useState, useEffect, useRef} from 'react';
import {shallowEqual, useSelector, useDispatch} from 'react-redux';
import _ from 'lodash';
import {Form, Input, Select, Spin, notification, DatePicker} from 'antd';
import {Modal, Button} from 'react-bootstrap';
import moment from 'moment';
import {toast} from 'react-toastify';

import * as actionsModal from 'src/setup/redux/modal/Actions';
import {useAuth} from 'src/app/modules/auth';

import {requestPOST, requestGET, requestPUT_NEW, API_URL, FILE_URL} from 'src/utils/baseAPI';

const FormItem = Form.Item;

const {Option} = Select;

const ModalItem = (props) => {
  const dispatch = useDispatch();
  const {currentUser} = useAuth();
  const currentPermissions = currentUser?.permissions;
  const random = useSelector((state) => state.modal.random);

  const [form] = Form.useForm();

  const [loadding, setLoadding] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoadding(true);
      const res = await requestGET(`api/personal/profile`);

      if (res) {
        form.setFieldsValue(res);
      }
      setLoadding(false);
    };

    fetchData();

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [random]);

  const onFinish = async () => {
    const values = await form.validateFields();

    try {
      const formData = form.getFieldsValue(true);

      const res = await requestPUT_NEW(`api/personal/profile`, formData);

      if (res.status === 200 || res.status === 502) {
        toast.success('Cập nhật thành công!');
        dispatch(actionsModal.setRandom());
      } else {
        //toast.error('Thất bại, vui lòng thử lại!');
        const errors = Object.values(res?.data?.errors ?? {});
        let final_arr = [];
        errors.forEach((item) => {
          final_arr = _.concat(final_arr, item);
        });
        toast.error('Thất bại, vui lòng thử lại! ' + final_arr.join(' '));
      }
    } catch (errorInfo) {
      console.log('Failed:', errorInfo);
    }
  };

  return (
    <>
      <div className='px-3 py-3 border-bottom border-secondary border-bottom-solid d-flex align-items-center justify-content-between'>
        <h3 className='card-title fw-bold text-header-td fs-4 mb-0'>{'Thông tin tài khoản'}</h3>
        <div className='d-flex align-items-center'>
          <button className='btn btn-primary btn-sm m-btn m-btn--icon py-2 me-2' onClick={onFinish}>
            <span>
              <i className='fas fa-save'></i>
              <span className=''>Cập nhật thông tin</span>
            </span>
          </button>
        </div>
      </div>

      <div className='card-body card-dashboard px-3 py-3'>
        <div className='card-dashboard-body table-responsive'>
          <Spin spinning={loadding}>
            {!loadding && (
              <Form form={form} layout='vertical' /* initialValues={initData} */ autoComplete='off'>
                <div className='row '>
                  <div className='col-xl-4'>
                    <FormItem label='Tên đăng nhập' name='userName' rules={[{required: true, message: 'Không được để trống!'}]}>
                      <Input placeholder='Tên đăng nhập' disabled={true} />
                    </FormItem>
                  </div>
                  <div className='col-xl-4'>
                    <FormItem label='Họ và tên' name='fullName' rules={[{required: true, message: 'Không được để trống!'}]}>
                      <Input placeholder='Họ và tên' />
                    </FormItem>
                  </div>
                  <div className='col-xl-4 col-lg-4'>
                    <FormItem label='Số điện thoại' name='phoneNumber' rules={[{required: true, message: 'Không được để trống!'}]}>
                      <Input placeholder='' />
                    </FormItem>
                  </div>
                  <div className='col-xl-4 col-lg-4'>
                    <FormItem label='Email' name='email'>
                      <Input placeholder='' />
                    </FormItem>
                  </div>
                  <div className='col-xl-4 col-lg-4'>
                    <FormItem label='Địa chỉ' name='address'>
                      <Input placeholder='' />
                    </FormItem>
                  </div>
                </div>
              </Form>
            )}
          </Spin>
        </div>
      </div>
    </>
  );
};

export default ModalItem;
